import type { IKpiRepository, KpiCreateInput } from '../repositories/IKpiRepository.js';
import type { KpiEntity } from '../entities/KpiEntity.js';

interface Deps { kpiRepository: IKpiRepository; }
export function createCreateKpiUseCase({ kpiRepository }: Deps) {
  return async function createKpi(input: KpiCreateInput): Promise<KpiEntity> {
    return kpiRepository.create(input);
  };
}
